import {LitElement, html, css} from 'lit';

export class LogoElement extends LitElement {
    static get styles() {
        return css`
            :host {
                display: block;
                width: 60px;
            }
            svg:hover .orbs {
                transform: rotate(180deg);
                transform-box: fill-box;
                transform-origin: center;
                animation: spin linear 1s infinite;
            }
            
            @keyframes spin {
                0% {
                    transform: rotate(0deg);
                }
                100% {
                    transform: rotate(360deg);
                }
            }
        `;
    }
    
    static get properties() {
        return {
            site: {type: Number},
        };
    }


    constructor() {
        super();
        this.site = 1;
    }

    renderSmutbaseLogo() {
        return html`
            <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 407.07 355.37">
                <path fill="#5f397d" d="M203.53 54 97.84 0 0 48v97.84l105.23 52.62v107.07l98.3 49.84 98.31-49.84V198.46l105.23-52.62V48L309.22 0 203.53 54z"/>
                <path fill="#333333" d="m308.3 27.69 57.23 28.62-162 82.14-162-82.14 57.24-28.62 104.76 52.15ZM27.23 78v58.15L132 188.3v106.15L190.15 324V160.15Zm189.69 82.15V324l58.15-29.54V188.3l104.77-52.15V78Z"/>
              </svg>
          `;
    }

    renderOpen3DLabLogo() {
        return html`
            <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 407.07 355.37">
                <path fill="#4056ad" d="M203.53 54 97.84 0 0 48v97.84l105.23 52.62v107.07l98.3 49.84 98.31-49.84V198.46l105.23-52.62V48L309.22 0 203.53 54z"/>
                <path fill="#e2e2e2" d="m308.3 27.69 57.23 28.62-162 82.14-162-82.14 57.24-28.62 104.76 52.15ZM27.23 78v58.15L132 188.3v106.15L190.15 324V160.15Zm189.69 82.15V324l58.15-29.54V188.3l104.77-52.15V78Z"/>
            </svg>
        `;
    }

    renderSFMLabLogo() {
        return html`
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 208 200">
                <g fill="#746c5f">
                    <path d="M137.95 31.88c3.53-2.6 7.05-5.21 10.6-7.78 4.29 5.77 8.44 11.66 12.9 17.3-13.97 10.41-28.31 20.31-42.44 30.51-1.93 1.83-4.93 1.69-6.9 0C100.85 63.3 86 59.55 72.02 61.99c-14.49 2.28-27.66 11.23-35.41 23.63-6.38 10.13-9.16 22.53-7.47 34.4 2.12 17.58 14.09 33.47 30.26 40.6 9.17 4.27 19.56 5.14 29.5 3.86 14.65-2.32 28.07-11.25 35.82-23.9 7.15-11.39 9.67-25.64 6.54-38.75-.32-1.89-1.36-4.42.75-5.63 15-10.69 29.87-21.6 45.28-31.72 3.74 6.23 7.99 12.19 11.5 18.52-3.1 2.75-7.05 4.6-10.48 7-2.18-2.82-3.87-5.97-5.92-8.88-9.5 6.11-19.01 12.21-28.5 18.33-.68 4.48-.83 9.02-.68 13.55.22 16.86-6.78 33.6-18.81 45.39-11.4 11.35-27.28 18.08-43.38 18.22-14.87.34-29.78-4.87-41.22-14.38-11.41-9.34-19.4-22.78-22.02-37.31-2.66-14.31-.23-29.54 6.93-42.24 8.87-16.09 25.14-27.87 43.2-31.28 16.34-3.34 33.61.53 47.54 9.51 9.39-7.11 19.07-13.85 28.57-20.82-2.03-2.73-4.07-5.46-6.07-8.21Z"/>
                    <path class="orbs" d="M78.44 74.58c7.36-2.18 15.39 4.99 14.39 12.54-.34 7.73-9.65 13.53-16.61 9.67-7.1-3.14-8.53-13.54-3.33-18.95 1.54-1.53 3.5-2.6 5.55-3.26ZM48.37 94.61c7.37-2.26 15.47 4.94 14.45 12.51-.3 8.34-11.01 14.09-17.88 8.91-8.27-4.94-6.16-19.36 3.43-21.42ZM105.44 94.59c6.94-2.06 14.66 4.26 14.42 11.4.3 6.33-5.58 12.35-11.96 11.93-4.83.08-9.11-3.57-10.73-7.97-.23-3.46-.88-7.42 1.4-10.38 1.49-2.52 4.15-4.1 6.87-4.98ZM78.2 107.25c5.27-1.77 10.99 3.41 9.74 8.83-.57 6.29-9.82 8.27-13.42 3.47-3.31-3.98-1.35-10.8 3.68-12.3ZM60.48 126.57c6.92-2.02 14.61 4.28 14.38 11.4.3 6.31-5.52 12.33-11.88 11.95-4.84.12-9.17-3.53-10.8-7.93-.2-3.25-.88-6.94 1.03-9.82 1.47-2.82 4.29-4.67 7.27-5.6ZM96.4 126.6c6.94-2.1 14.71 4.24 14.46 11.4.3 6.31-5.55 12.32-11.91 11.92-4.84.1-9.14-3.54-10.77-7.94-.25-3.46-.89-7.42 1.38-10.39 1.48-2.51 4.12-4.11 6.84-4.99Z"/>
                </g>
            </svg>
        `;
    }

    _clicked() {
        this.clicked = !this.clicked;
    }

    render() {
        if (this.site === 1) {
            return this.renderSmutbaseLogo();
        } else if (this.site === 2) {
            return this.renderOpen3DLabLogo();
        } else if (this.site === 3) {
            return this.renderSFMLabLogo();
        }

        return this.renderSFMLabLogo();
    }
}

window.customElements.define('logo-element', LogoElement);